import { INCLUDE_CREDENTIALS } from '../constants';
const apiSupportsCredentials = process.env.BLAZE_GRAPHQL_CORS_CREDENTIALS_ENABLE === 'true';
const getApiCredentialsSetting = () => apiSupportsCredentials ? INCLUDE_CREDENTIALS : undefined;
export default getApiCredentialsSetting;
//# sourceMappingURL=get-api-credentials-setting.js.map